<template>
  <v-dialog v-if="pendingBox" v-model="dialog">
    <template #activator="{on}">
        <v-btn v-on="on" :disabled="!canTranfer">
            Transfer Product from Pending Box
        </v-btn>
    </template>
    <v-card>
        <v-card-title>
            Transfer Product from Pending Box
        </v-card-title>
        <v-card-text>
            <v-data-table
                :items="pendingBox.items"
                :headers="headers"
            >
                <template #[`item.transfer`]="{item}">
                    <v-text-field type="number" :max="item.quantity" :min="0" v-model="toTransfer[item.id]" />
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false">
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn color="green" dark @click="doTransfer">
                Transfer
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        handling: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        pendingBox: null,
        headers: [
            { text:'Product', value: 'product.name'},
            { text:'SKU', value: 'product.sku'},
            { text:'Quantity in the box', value: 'quantity'},
            { text:'Quantity to transfer', value: 'transfer'},
        ],
        toTransfer:{}
    }),
    computed: {
        orderId () {
            return this.handling.build.order_id
        },
        productToTransfer () {
            return Object.entries(this.toTransfer).map(([k,v]) => {return {pendingBoxItem:k, quantity:v} })
        },
        canTranfer () {
            return this.pendingBox && this.pendingBox.items.length && ['building', 'on cart'].includes(this.handling.status_id)
        }
    },
    mounted(){
        this.fetchPendingBox()
    },
    methods: {
        ...mapActions('pendingbox', {getPendingBoxByOrderId: 'getByOrderId'}),
        ...mapActions('handling', {transferProductFromPendingBox: 'transferProductFromPendingBox'}),
        fetchPendingBox(){
            this.getPendingBoxByOrderId(this.orderId).then(({pendingBox}) => {
                this.pendingBox = pendingBox
            })
        },
        doTransfer () {
            
            this.transferProductFromPendingBox({
                handlingId: this.handling.id,
                products: this.productToTransfer
            }).then(() => {
                this.fetchPendingBox()
                this.dialog=false
                this.$emit("update")
            })
        },
        
    }
}
</script>

<style>

</style>